<template>
  <section class="shop-car-steps flex text-center">
    <div 
      v-for="(item, index) in list" 
      :key="index" 
      class="shop-car-step pointer"
      :class="[
        {'active': index === step },
        {'is-done': index < step},
      ]"
    >
      <p class="shop-car-step-number after relative">
        <span class="index">{{index+1}}</span>  
      </p>
      <p class="step-label">{{index+1}}.{{item}}</p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [
        '我的购物车', '填写核对订单信息', '成功提交订单',
      ],
    },
    step: {
      type: Number,
      default: 0,
    }
  },
  data: ()=>({

  })
}
</script>

<style lang="less" scoped>
@iconHeight: .2rem;
.shop-car-step-number{
  height: @iconHeight;
  line-height: @iconHeight;
  min-width: 1.6rem;
  padding: 0 .1rem;
  z-index: 1;
  
  .index{
    width: @iconHeight;
    display: block;
    height: 100%;
    margin: 0 auto;
    background: #ccc;
    border-radius: 50%;
    font-size: 12px;
    color: #fff;
  }

  &::after{
    width: 100%;
    height: .05rem;
    background: #ccc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: @iconHeight;
    z-index: -1;
  }
}
.shop-car-step:nth-of-type(2) .shop-car-step-number::after{
  border-radius: 0;
}
.shop-car-step:nth-of-type(3) .shop-car-step-number::after{
  border-radius: 0 @iconHeight @iconHeight 0;
}

.shop-car-step {
  &.active{
    .renderProcess(#D8271C);
  }
  &.is-done{
    .renderProcess(#FFCCC9);
  }
}

.step-label{
  font-size: .16rem;
  color: #ccc;
  margin-top: .02rem;
}

// 渲染进度条 function
.renderProcess(@color){
  .shop-car-step-number{
    .index{
      background: @color;
    }
    &::after{
      background: @color;
      border-radius: @iconHeight;
    }
  }
  .step-label{
    color: @color;
  }
}
</style>